import React from 'react';
import "./Calltoaction.scss";
const Calltoaction = () => {
  return (
        <div className="hero-banner">
            <p>¿BUSCANDO AYUDA LEGAL?</p>
            <a 
              href="https://wa.me/56973985781" 
              target="_blank" 
              rel="noopener noreferrer"
              className="hero-button"
            >
                WHATSAPP AHORA! <span>➝</span>
            </a>
        </div>
  )
}

export default Calltoaction